$(document).ready(function () {
  const phoneInput = $('.phone-number-input');

  if (!phoneInput.length) return;

  var preferredCountries = phoneInput.data('preferred-countries') || ['FR', 'BE', 'CH', 'LU'];
  if (typeof preferredCountries === 'string') {
    preferredCountries = JSON.parse(preferredCountries);
  }

  phoneInput.intlTelInput({
    initialCountry: getCurrentLocale() === 'es' ? 'ES' : 'FR',
    preferredCountries: preferredCountries,
    separateDialCode: true,
    formatOnDisplay: true,
    autoHideDialCode: false,
    nationalMode: false,
    hiddenInput: 'full',
  });

  phoneInput.closest('form').on('submit', function (e) {
    phoneInput.removeClass('error');
    if (phoneInput.intlTelInput('isValidNumber') &&
      [
        intlTelInputUtils.numberType.MOBILE,
        intlTelInputUtils.numberType.FIXED_LINE_OR_MOBILE,
      ].includes(phoneInput.intlTelInput('getNumberType'))) {
      phoneInput.val(phoneInput.intlTelInput('getNumber'));
    } else {
      const currentLocale = getCurrentLocale();
      const errorMessage = {
        fr: 'Le numéro renseigné doit correspondre à un téléphone mobile.',
        en: 'Please fill in a mobile phone number.',
        es: 'El número de teléfono debe ser un número de móvil.',
      };

      toastr.error(errorMessage[currentLocale]);

      e.preventDefault();
      phoneInput.addClass('error');
      return false;
    }
  });

  const taxLocationDifferentFromResidenceInput = $(
    '#users_profile_user_attributes_tax_location_different_from_residence'
  );

  function updateNifVisibility() {
    const taxDifferent = $('#users_profile_user_attributes_tax_location_different_from_residence').prop('checked');
    let effectiveCountry;

    if (taxDifferent) {
      effectiveCountry = $('#country_autocomplete_3').val();
    } else {
      effectiveCountry = $('#country_autocomplete_2').val();
    }

    if (effectiveCountry && effectiveCountry !== 'FR') {
      $('#nifField').removeClass('d-none');
    } else {
      $('#nifField').addClass('d-none');
    }
  }

  if (taxLocationDifferentFromResidenceInput.length) {
    const taxLocationOnChange = function() {
      if ($('#users_profile_user_attributes_tax_location_different_from_residence').prop('checked')) {
        $('.tax-location-form-container').removeClass('d-none');
        $('.tax-location-form-container .is_required').attr('required', 'required');
        $('#destroyTaxLocation').val('0');
      } else {
        $('.tax-location-form-container').addClass('d-none');
        $('.tax-location-form-container .is_required').attr('required', false);
        $('#destroyTaxLocation').val('1');
      }
      updateNifVisibility();
    };

    taxLocationDifferentFromResidenceInput.on('change', taxLocationOnChange);
    taxLocationOnChange();

    $('#country_autocomplete_2').on('change', updateNifVisibility);
    $('#country_autocomplete_3').on('change', updateNifVisibility);
  }
});
